import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ajouteOffre, suprimerOffre } from '../Redux/actions/actionOffre';
import { ajouteReservation } from '../Redux/actions/actionReservation';
import { suprimerCreneau } from '../Redux/actions/actionCreneau';
import Spinner from "react-bootstrap/Spinner";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Pagination from '@material-ui/lab/Pagination';
import Slider from "react-slick";
import '../Css/restoPage.css';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import { PhotoProvider, PhotoView } from 'react-photo-view';

import Chef from "../Image/chef.png";
import EntrerIcon from "../Image/entrer.png";
import PlatIcon from "../Image/plats.png";
import DessertIcon from "../Image/desserts.png";
import Menus from "../Image/menus.png";
import Boisson from "../Image/boisson.png";
import Money from "../Image/money.png";
import Plus from "../Image/plus.png";
import Avatar1 from "../Image/avatar1.png";
import Avatar2 from "../Image/Avatar2.png";
import { BASE_URL } from '../Utils/base_url';
import { AfficheAvisResto, AfficheRestaurant, AjouteFavorie } from '../Api/RestoPageApi';
import { AfficheHero } from '../Api/HomeApi';
import db from '../db';
import { AjouteDataRestaurant } from '../Redux/actions/actionDataRestaurant';


const RestoPage = () => {

  const [loadData, setLoadData] = useState(false);
  const [loadResto, setLoadResto] = useState(false);
  const [show, setShow] = useState(false);
  const [showSpecial, setShowSpecial] = useState(false);
  const [dataMenu, setDataMenu] = useState([]);
  const [dataMenuSpecial, setDataMenuSpecial] = useState([]);
  const [openDropDown, setOpenDropDown] = useState(false);


  const [data, setData] = useState([]);
  const [dataResto, setDataResto] = useState([]);
  const [totalAvis, setTotalAvis] = useState([]);
  const [showPaginate, setShowPaginate] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);


  const [imageUrl, setImageUrl] = useState('');
  const [imageLoad, setImageLoad] = useState(false);


  let location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { idRestaurant } = useParams();

  const client = useSelector((state) => state.client);
  const creneauData = useSelector((state) => state.creneau);

  const [test, setTest] = useState([]);

  useEffect(() => {
    const fetchAndSetData = async () => {
      try {
        const donner = await db.monTableau.toArray();
        if (donner.length > 0) {
          setTest(donner.find((el) => el.id === parseInt(idRestaurant)));
          console.log("Donner dans dexi=>", donner);
          dispatch(AjouteDataRestaurant(donner));
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données depuis Dexie :', error);
      }
    };
    fetchAndSetData();
  }, [dispatch, idRestaurant]);


  console.log("Donner dans test", test);

  useEffect(() => {
    setImageLoad(true);
    AfficheHero().then(function (response) {
      console.log('Liste photo =>', response.data.donner);
      setImageUrl(response.data.donner[0].imageUrl);
      localStorage.setItem('urlHero', response.data.donner[0].imageUrl);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setImageLoad(false);
    });

  }, []);


  useEffect(() => {
    AfficheResto();
    AfficheAvis();
    if (totalAvis.length < 5) {
      setShowPaginate(false);
    } else {
      setShowPaginate(true);
    }
  }, [totalAvis.length]);

  const AfficheAvis = (value = null) => {
    let dataPage = value === null ? page : value;
    setLoadData(true);
    AfficheAvisResto(idRestaurant, dataPage)
      .then(function (response) {
        setData(response.data.donner);
        setTotalAvis(response.data.totalResa);
        setTotalPage(response.data.totalPage);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoadData(false);
      });
  };


  const AfficheResto = () => {
    setLoadResto(true);
    AfficheRestaurant(idRestaurant)
      .then(function (response) {
        setDataResto(response.data.donner);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoadResto(false);
      });
  }


  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    speed: 2000,
    autoplaySpeed: 8000,
    swipeToSlide: true,
    slidesToShow: dataResto?.photos?.length < 4 ? dataResto?.photos?.length : 4,
    slidesToScroll: dataResto?.photos?.length < 4 ? dataResto?.photos?.length : 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: dataResto?.photos?.length < 3 ? dataResto?.photos?.length : 3,
          slidesToScroll: dataResto?.photos?.length < 3 ? dataResto?.photos?.length : 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: dataResto?.photos?.length < 2 ? dataResto?.photos?.length : 2,
          slidesToScroll: dataResto?.photos?.length < 2 ? dataResto?.photos?.length : 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: dataResto?.photos?.length < 1 ? dataResto?.photos?.length : 1,
          slidesToScroll: dataResto?.photos?.length < 1 ? dataResto?.photos?.length : 1
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: dataResto?.photos?.length < 1 ? dataResto?.photos?.length : 1,
          slidesToScroll: dataResto?.photos?.length < 1 ? dataResto?.photos?.length : 1
        }
      }
    ]
  };


  const handleClose = () => setShow(false);
  const handleCloseSpecial = () => setShowSpecial(false);

  const handleShow = (data) => {
    setDataMenu(data);
    setShow(true);
  };

  const handleShowSpecial = (data) => {
    setDataMenuSpecial(data);
    setShowSpecial(true);
  }



  const viewPromotion = () => {
    const existePromo50 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = dataResto?.promotions?.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return (<span onClick={() => handleOffre(existePromo50)}><i className='fa fa-bullhorn'></i>Promotion -50%</span>);
    } else if (existePromo40) {
      return (<span onClick={() => handleOffre(existePromo40)}><i className='fa fa-bullhorn' ></i>Promotion -40%</span>);
    } else if (existePromo30) {
      return (<span onClick={() => handleOffre(existePromo30)}><i className='fa fa-bullhorn' ></i>Promotion -30%</span>);
    } else if (existePromo20) {
      return (<span onClick={() => handleOffre(existePromo20)}><i className='fa fa-bullhorn' ></i>Promotion -20%</span>);
    } else if (existePromo10) {
      return (<span onClick={() => handleOffre(existePromo10)}><i className='fa fa-bullhorn' ></i>Promotion -10%</span>);
    } else if (existePromoSpecial) {
      return (<span onClick={() => handleOffre(existePromoSpecial)}><i className='fa fa-bullhorn' ></i>Menu spécial</span>);

    } else {
      return (<span><i className='fa fa-bullhorn'></i>Pas de promotion ...</span>);
    }


  }


  const DataPromotion = () => {
    const existePromo50 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = dataResto?.promotions?.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = dataResto?.promotions?.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return existePromo50;
    } else if (existePromo40) {
      return existePromo40;
    } else if (existePromo30) {
      return existePromo30;
    } else if (existePromo20) {
      return existePromo20;
    } else if (existePromo10) {
      return existePromo10;
    } else if (existePromoSpecial) {
      return existePromoSpecial;
    }


  }

  const viewCreneau = (value) => {
    var opt_month = { month: 'long' };
    function toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    }
    var MonthDu = toTitleCase(new Date(value?.du).toLocaleDateString("fr-FR", opt_month));
    var MonthAu = toTitleCase(new Date(value?.au).toLocaleDateString("fr-FR", opt_month));
    const date = new Date();
    const du = new Date(value?.du);
    const fin = new Date(value?.au).getTime();
    const au = new Date(value?.au);
    if (fin >= date.getTime()) {
      return (<p>{du.getDate() + " " + MonthDu + " " + du.getFullYear()} au {au.getDate() + " " + MonthAu + " " + au.getFullYear()}</p>);
    } else {
      return (<p>Promotion Expirée !</p>)
    }

  }

  const handleReserver = () => {
    if (!localStorage.getItem('tokenClient')) {
      navigate("/loginClient");
      localStorage.setItem('urlClient', `/restoPage/${idRestaurant}`);
    } else {
      navigate(`/reserverSansCritere/${idRestaurant}`);
      const date = new Date();
      const au = new Date(test?.creneauPromos[0]?.au);
      if (au.getFullYear() >= date.getFullYear() && parseInt(au.getMonth() + 1) >= parseInt(date.getMonth() + 1) && au.getDate() >= date.getDate()) {
        dispatch(ajouteOffre(DataPromotion()));
        localStorage.setItem('offre', JSON.stringify(DataPromotion()));
      }
      localStorage.removeItem('urlClient');
    }
  }

  const handleOffre = (offre) => {
    if (!localStorage.getItem('tokenClient')) {
      navigate("/loginClient");
      localStorage.setItem('urlClient', `/restoPage/${idRestaurant}`);
    } else {
      navigate(`/reserverSansCritere/${idRestaurant}`);
      const date = new Date();
      const au = new Date(test?.creneauPromos[0]?.au);
      if (au.getFullYear() >= date.getFullYear() && parseInt(au.getMonth() + 1) >= parseInt(date.getMonth() + 1) && au.getDate() >= date.getDate()) {
        dispatch(ajouteOffre(offre));
        localStorage.setItem('offre', JSON.stringify(offre));
      }
      localStorage.removeItem('urlClient');
    }
  }

  const handlePage = (event, value) => {
    setPage(value);
    AfficheAvis(value);
  }

  const plural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  const viewDate = (value) => {
    const date = new Date(value);
    return plural(date.getDate()) + "/" + plural(parseInt(date.getUTCMonth() + 1)) + "/" + date.getFullYear();
  }

  const viewAvis = (item, index) => {
    const nom = item.client.nom.charAt(0).toUpperCase();
    const prenom = item.client.prenom.charAt(0).toUpperCase();

    const clientAvis = data.filter((el) => el.client.id === item.client.id);

    return (
      <div className='resto_avis_liste' key={index}>
        <div className='row'>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_avis_profile'>
              <div className='resto_avatar_client'>
                {
                  item.client.sexe === "Homme" ? <img src={Avatar2} alt="avatar client" /> : <img src={Avatar1} alt="avatar client" />
                }
              </div>
              {item.client.affichagePseudo === "1" ?
                <div className='pseudoClient d-flex flex-column'>
                  <span>{item.client.nom}</span>
                  <span className='text-center'>{item.client.prenom}</span>
                </div>
                : item.client.affichagePseudo === "2" ?
                  <span>{item.client.prenom} {nom}</span>
                  : item.client.affichagePseudo === "3" ?
                    <span>{prenom} {item.client.prenom}</span>
                    : <span>{nom} {prenom}</span>}

            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
            <div className='resto_note_avis'>
              <div className='d-flex justify-content-center'>
                <div className='note_avis_content'>
                  <div>
                    <div className='resto_note_value'>Note/<span>{item.notes[0]?.note}</span></div>
                    <div className='resto_avis_value'>Avis/<span>{clientAvis.length}</span></div>
                  </div>
                </div>
              </div>
              <div className='resto_avis_date'>
                <span>{viewDate(item.createdAt)}</span>
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
            <div className='resto_content_avis'>
              <p>{item.avis}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const safeParseFloat = (str) => {
    const value = Number.parseFloat(str);

    return Number.isNaN(value) ? 0 : value;
  };
  const viewNote = (value) => {
    const notesArray = Array.isArray(value) ? value : [];
    const notesSum = notesArray.reduce(
      (prevNote, currentNote) => prevNote + parseInt(currentNote.note || 0),
      0
    );

    const numberOfNotes = notesArray.length > 0 ? notesArray.length : 1; // Assurez-vous d'utiliser au moins 1 pour éviter la division par zéro.

    const averageNote = notesSum / numberOfNotes;
    return averageNote.toFixed(0);
  };


  const handleReset = () => {
    AfficheAvis();
  }

  const handleDrop = () => {
    setOpenDropDown(!openDropDown);
  }


  const handleCroissonAvis = () => {
    const sorted = [...totalAvis].sort((a, b) => a.id > b.id ? 1 : -1);
    setData(sorted);
  }

  const handleDeCroissonAvis = () => {
    const sorted = [...totalAvis].sort((a, b) => a.id < b.id ? 1 : -1);
    setData(sorted);
  }

  const handleCroissonNote = () => {
    const sorted = [...totalAvis].sort((a, b) => parseFloat(a.notes[0]?.note) > parseFloat(b.notes[0]?.note) ? 1 : -1);
    setData(sorted);
  }

  const handleDeCroissonNote = () => {
    const sorted = [...totalAvis].sort((a, b) => parseFloat(a.notes[0]?.note) < parseFloat(b.notes[0]?.note) ? 1 : -1);
    setData(sorted);
  }
  const handleAddFavoris = () => {
    if (!localStorage.getItem('tokenClient')) {
      navigate("/loginClient");
      localStorage.setItem('urlClient', `/restoPage/${idRestaurant}`);
    } else {
      setLoadResto(true);
      const data = { idClient: client.id, idRestaurant: idRestaurant };
      AjouteFavorie(data).then(function (response) {
        AfficheResto();
      })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoadResto(false);
        });
    }
  }



  const viewFavoris = () => {
    const favoriteExist = dataResto.favoris?.find((el) => el.client.id === client.id && el.restaurant.id === parseInt(idRestaurant));
    if (localStorage.getItem('tokenClient')) {
      if (favoriteExist) {
        return (
          <div className='favoris_gif'>
            <i className='fa fa-heart' onClick={handleAddFavoris}></i>
          </div>

        )
      } else {
        return (
          <div className='favoris_gif'>
            <i className='fa fa-heart-o' onClick={handleAddFavoris}></i>
          </div>)
      }

    } else {
      return (
        <div className='favoris_gif'>
          <i className='fa fa-heart-o' onClick={handleAddFavoris}></i>
        </div>)
    }


  }

  const handleReserverResto = (id, creneau) => {
    if (!localStorage.getItem('tokenClient')) {
      navigate("/loginClient");
      localStorage.removeItem('creneau');
    } else {
      const data = { date: creneauData.date, heure: creneau, personne: creneauData.personne };
      localStorage.setItem('reservation', JSON.stringify(data));
      dispatch(ajouteReservation(data));
      const date = new Date();
      const au = new Date(test?.creneauPromos[0]?.au);
      if (au.getFullYear() <= date.getFullYear() && parseInt(au.getMonth() + 1) <= date.getMonth() && au.getDate() <= date.getDate()) {
        dispatch(ajouteOffre(DataPromotion()));
      }
      dispatch(suprimerCreneau());
      localStorage.removeItem('creneau');
      navigate('/finaliserReservation', { state: { idRestaurant: id } });
    }
  }

  const formatDate = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }



  const viewCreneauList = () => {

    var firstTime = new Date("2000-01-01 " + creneauData.heure + ":00");

    var secondeTime = new Date("2000-01-01 " + creneauData.heure + ":00");
    secondeTime.setMinutes(secondeTime.getMinutes() + 30);
    secondeTime = new Date(secondeTime);

    var lastTime = new Date("2000-01-01 " + creneauData.heure + ":00");
    lastTime.setMinutes(lastTime.getMinutes() + 60);
    lastTime = new Date(lastTime);


    var creneau1 = formatDate(firstTime.getHours()) + ":" + formatDate(firstTime.getMinutes());
    var creneau2 = formatDate(secondeTime.getHours()) + ":" + formatDate(secondeTime.getMinutes());
    var creneau3 = formatDate(lastTime.getHours()) + ":" + formatDate(lastTime.getMinutes());

    console.log("Creneau time =>", creneau1 + " " + creneau2 + " " + creneau3);

    return (<div className='item_action_creneau'>
      <span className="item_creneau" onClick={() => handleReserverResto(idRestaurant, creneau1)}>{creneau1}</span>
      {test?.informations?.map((el, i) => {
        if (creneau2 >= new Date(el.heureDebut).getUTCHours() + ":" + new Date(el.heureDebut).getMinutes() && creneau2 < new Date(el.heureFin).getUTCHours() + ":" + new Date(el.heureFin).getMinutes()) {
          return (<span key={i} className="item_creneau" onClick={() => handleReserverResto(idRestaurant, creneau2)}>{creneau2}</span>)
        } else {
          return ('')
        }
      })}
      {test?.informations?.map((el, i) => {
        if (creneau3 >= new Date(el.heureDebut).getUTCHours() + ":" + new Date(el.heureDebut).getMinutes() && creneau3 < new Date(el.heureFin).getUTCHours() + ":" + new Date(el.heureFin).getMinutes()) {
          return (<span key={i} className="item_creneau" onClick={() => handleReserverResto(idRestaurant, creneau3)}>{creneau3}</span>)
        } else {
          return ('')
        }
      })}
    </div>)
  }




  return (
    <div>
      <Helmet>
        <title>Restaurant ~ Page</title>
        <meta name='description' content='Restaurant page.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <NavBar />

      <div className='restoPage'>
        <div className='restoPage_content'>
          <Hero ou="" qoui="" date="" heure="" personne="" imageLoad={imageLoad} imageUrl={imageUrl} />
          {loadResto ?
            <p style={{ fontSize: '14px', marginTop:'10px' }}>Chargement du restaurant...</p>
            :
            <>
              <div className='resto_option'>

                <div className='row'>
                  <div className='col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8'>
                    <div className='resto_apropos'>
                      <div className='resto_apropos_content'>
                        <h1 className='text-center'>{test.nomRestaurant}</h1>
                        <div className='cuisine_prix'>
                          <div className="row">

                            {dataResto.typeCuisines?.length !== 0 ?
                              dataResto.typeCuisines?.map((item, index) => {
                                return (
                                  <div className='col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-3' key={index}>
                                    <span ><i className='fa fa-cutlery'></i>{item.libelle}</span>
                                  </div>
                                )
                              })
                              : ''}

                          </div>
                          <div className='row'>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                              <span><i className='fa fa-map-marker'></i>{dataResto.adresse}</span>
                            </div>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                              <span><i className='fa fa-bookmark'></i>Prix Moyenne de {dataResto.prixMoyenne ? dataResto.prixMoyenne[0]?.prix : 0} Ar</span>
                            </div>

                          </div>
                        </div>

                        {loadResto === true ?
                          <div className='favoris_load'>
                            <Spinner
                              animation="border"
                              className="load"
                              variant="light"
                              size="md"
                            />
                          </div> : viewFavoris()
                        }

                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
                    <div className='resto_favoris'>
                      <div className='resto_favoris_content'>
                        <div className="d-flex justify-content-center">
                          <div className='resto_note_avis'>
                            <div>
                              <div className='resto_note'>Note/<span>{dataResto?.notes && dataResto?.notes?.length === 0 ? 0 : viewNote(dataResto?.notes)}</span></div>
                              <div className='resto_avis'>Avis/<span>{dataResto?.avis && dataResto?.avis?.length === 0 ? 0 : dataResto?.avis?.length}</span></div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-center">
                          {dataResto?.promotions?.length === 0 ? <div className='resto_promotion mb-4'>
                            {viewPromotion()}
                          </div> :
                            <div className='resto_promotion'>
                              {viewPromotion()}
                              {dataResto?.creneauPromos ?
                                viewCreneau(dataResto?.creneauPromos[0])
                                : ''}


                            </div>}
                        </div>
                      </div>
                      <div className='resto_footer_reserver'>
                        {creneauData.length !== 0 ?
                          viewCreneauList()
                          :
                          <div className='d-flex justify-content-center'>
                            <button className="btn" onClick={handleReserver}>Réserver</button>
                          </div>
                        }

                      </div>
                    </div>
                  </div>
                </div>


              </div>


              <PhotoProvider>
                <div className='resto_photos'>
                  {dataResto?.photos?.length !== 0 ?
                    <Slider {...settings}>
                      {dataResto?.photos?.map((item, index) => {
                        return (<div className='image' key={index}>
                          <PhotoView src={item.basePhoto}>
                            <img src={item.basePhoto} alt="logo restaurant" />
                          </PhotoView>
                        </div>)
                      })}
                    </Slider>
                    : <p>Photos non disponible ...</p>}

                </div>
              </PhotoProvider>
              <div className='resto_description'>
                <h2> <i className='fa fa-tag'></i>Description du restaurant</h2>
                <div className='resto_description_content'>
                  <div className='chef'>
                    <img src={Chef} alt="chef avatar" />
                  </div>
                  <p>
                    {dataResto?.description === null
                      ? 'Description non disponible ...'
                      : dataResto?.description
                        ? dataResto.description.split('\n').map((line, index) => (
                          <div key={index}>{line}</div>
                        ))
                        : 'Description non disponible ...'
                    }
                  </p>
                </div>

              </div>
              <div className='row'>


                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8'>
                  <Tabs
                    defaultActiveKey="carte"
                    id="fill-tab-example"
                    className="mb-3"
                    justify
                  >
                    <Tab eventKey="carte" title="Cartes">
                      {dataResto?.entrers?.length === 0 && dataResto?.plats?.length === 0 && dataResto?.desserts?.length === 0 && dataResto?.boissons?.length === 0 ?
                        <h4> <i className='fa fa-cutlery pas'></i>Pas de contenue dans la carte</h4>
                        :
                        <h4> <i className='fa fa-cutlery'></i>A la carte</h4>
                      }

                      <div className='resto_carte'>
                        <div className='row'>
                          {dataResto?.entrers?.length !== 0 ?
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                              <div className='resto_carte_bloc'>
                                <h5 className='text-center'>Entrées</h5>
                                {dataResto?.entrers?.map((item, index) => {
                                  if (index === dataResto?.entrers?.length - 1) {
                                    return (<div className='resto_entrer' key={index}>
                                      <div className='img'>
                                        <img src={EntrerIcon} alt="avatar carte" />
                                      </div>
                                      <div className='resto_carte_content'>
                                        <h6>{item.libelle}</h6>
                                        <span>{item.prix} Ar</span>
                                      </div>
                                    </div>)
                                  } else {
                                    return (<>
                                      <div className='resto_entrer' key={index}>
                                        <div className='img'>
                                          <img src={EntrerIcon} alt="avatar carte" />
                                        </div>
                                        <div className='resto_carte_content'>
                                          <h6>{item.libelle}</h6>
                                          <span>{item.prix} Ar</span>
                                        </div>
                                      </div>
                                      <hr />
                                    </>)
                                  }

                                })}


                              </div>
                            </div>
                            : ''}

                          {dataResto?.plats?.length !== 0 ?
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                              <div className='resto_carte_bloc'>
                                <h5 className='text-center'>Plats</h5>
                                {dataResto?.plats?.map((item, index) => {
                                  if (index === dataResto?.plats?.length - 1) {
                                    return (<div className='resto_plat' key={index}>
                                      <div className='img'>
                                        <img src={PlatIcon} alt="avatar carte" />
                                      </div>
                                      <div className='resto_carte_content'>
                                        <h6>{item.libelle}</h6>
                                        <span>{item.prix} Ar</span>
                                      </div>
                                    </div>)
                                  } else {
                                    return (<>
                                      <div className='resto_plat' key={index}>
                                        <div className='img'>
                                          <img src={PlatIcon} alt="avatar carte" />
                                        </div>
                                        <div className='resto_carte_content'>
                                          <h6>{item.libelle}</h6>
                                          <span>{item.prix} Ar</span>
                                        </div>
                                      </div>
                                      <hr />
                                    </>
                                    )
                                  }

                                })}

                              </div>
                            </div>
                            : ''}


                          {dataResto?.desserts?.length !== 0 ?
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                              <div className='resto_carte_bloc'>
                                <h5 className='text-center'>Desserts</h5>

                                {dataResto?.desserts?.map((item, index) => {
                                  if (index === dataResto?.desserts?.length - 1) {
                                    return (
                                      <div className='resto_dessert' key={index}>
                                        <div className='img'>
                                          <img src={DessertIcon} alt="avatar carte" />
                                        </div>
                                        <div className='resto_carte_content'>
                                          <h6>{item.libelle}</h6>
                                          <span>{item.prix} Ar</span>
                                        </div>
                                      </div>
                                    )
                                  } else {
                                    return (
                                      <>
                                        <div className='resto_dessert' key={index}>
                                          <div className='img'>
                                            <img src={DessertIcon} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>
                                        <hr />
                                      </>
                                    )
                                  }
                                })}


                              </div>

                            </div>
                            : ''}


                          {dataResto?.boissons?.length !== 0 ?

                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
                              <div className='resto_carte_bloc'>
                                <h5 className='text-center boisson'>Boissons</h5>
                                {dataResto?.boissons?.map((item, index) => {
                                  if (index === dataResto?.boissons?.length - 1) {
                                    return (
                                      <div className='resto_boisson' key={index}>
                                        <div className='img'>
                                          <img src={Boisson} alt="avatar carte" />
                                        </div>
                                        <div className='resto_carte_content'>
                                          <h6>{item.libelle}</h6>
                                          <span>{item.prix} Ar</span>
                                        </div>
                                      </div>
                                    )
                                  } else {
                                    return (
                                      <>
                                        <div className='resto_boisson' key={index}>
                                          <div className='img'>
                                            <img src={Boisson} alt="avatar carte" />
                                          </div>
                                          <div className='resto_carte_content'>
                                            <h6>{item.libelle}</h6>
                                            <span>{item.prix} Ar</span>
                                          </div>
                                        </div>
                                        <hr />
                                      </>
                                    )
                                  }
                                })}



                              </div>

                            </div>
                            : ''}

                        </div>
                      </div>
                    </Tab>



                    <Tab eventKey="menu" title="Menus">
                      {dataResto?.menus?.length === 0 ? <h4> <i className='fa fa-cutlery pas'></i>Pas de contenu dans le Menus</h4> : <h4> <i className='fa fa-cutlery'></i>Menus</h4>}

                      <div className="row p-2">

                        {dataResto?.menus?.map((item, index) => {
                          return (
                            <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4' key={index}>
                              <div className='resto_menus'>
                                <div className='resto_menu_header'>
                                  <div className='img'>
                                    <img src={Menus} alt="avatar menus" />
                                  </div>
                                  <div className='resto_menu_titre'>
                                    <h5>{item.nomMenu} à <span>{item.prixMenu} Ar</span></h5>
                                  </div>
                                </div>
                                <div className='resto_menu_content'>
                                  <p>{item.introduire.slice(0, 80)}...</p>
                                  <div className='d-flex justify-content-center'>
                                    <button className='btn' onClick={() => handleShow(item)}>Voir le détail de ce menu</button>
                                  </div>
                                </div>

                              </div>
                            </div>
                          );
                        })}

                      </div>


                    </Tab>



                    <Tab eventKey="avecOffre" title="Avec Offres">
                      <div className='resto_promo_map'>
                        <div className='row'>
                          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='resto_promo_titre'>
                              <h4> <i className='fa fa-bullhorn'></i>Avec Offre</h4>
                            </div>
                            <div className='resto_promo_content'>

                              {dataResto?.promotions?.length !== 0 ?
                                dataResto?.promotions?.map((item, index) => {
                                  if (item.libelle !== "Promotion : Menu spécial") {
                                    return (<div className='resto_promo_content_item' key={index}>
                                      <div className='item_liste'>
                                        <h5>{item.libelle} sur la carte</h5>
                                        <span>Précision / conditions / validité</span>
                                      </div>
                                      {creneauData.length !== 0 ?
                                        viewCreneauList()
                                        : <div className='reserver'>
                                          <button className='btn btn_promoReserver' onClick={() => handleOffre(item)}>Reserver</button>
                                        </div>}
                                    </div>)
                                  } else {

                                    return dataResto?.promoSpecial?.map((menu, i) => {
                                      return (
                                        <div className='resto_promo_content_item' key={i}>
                                          <div className='item_liste'>
                                            <h5>{menu.libelle} à {menu.prix} Ar</h5>
                                            <span>Précision / conditions / validité</span>
                                          </div>
                                          <div className='item_action_creneau creneau_special'>
                                            <span className="item_detail_menu" onClick={() => handleShowSpecial(menu)}>Voir le détail de ce menu</span>
                                          </div>
                                          <div className='item_action_content'>
                                            {creneauData.length !== 0 ?
                                              viewCreneauList()
                                              : <div className='reserver'>
                                                <button className='btn btn_promoReserver' onClick={() => handleOffre(item)}>Reserver</button>
                                              </div>}

                                            <div className='item_action_creneau_responsive'>
                                              <span className="item_detail_menu" onClick={() => handleShowSpecial(menu)}>Voir le détail de ce menu</span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })


                                  }

                                })
                                : <p>Pas de promotion ...</p>}


                            </div>
                            <div className='resto_promo_titre mt-3'>
                              <h4> <i className='fa fa-bullhorn'></i>Sans Offre</h4>
                            </div>
                            <div className='resto_promo_content'>
                              <div className='resto_promo_content_item'>
                                <div className='item_liste'>
                                  <h5>Réservations simple</h5>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </Tab>




                    <Tab eventKey="avis" title={"Nombre d'avis " + dataResto?.avis?.length}>
                      <div className='resto_avis'>
                        <div className='resto_avis_header'>
                          <h4><i className='fa fa-tag'></i> Nombre d'avis {dataResto?.avis?.length}</h4>
                          {dataResto?.avis?.length !== 0 ?
                            <button className='btn' onClick={handleDrop}>Trier par :</button>
                            : ""}

                        </div>
                        <div className='col-xs-12 col-12 col-sm-12'>
                          <div className='d-flex justify-content-end'>
                            <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                              <div className="filter-content">
                                <div className="filter_titre">
                                  <li className='filter_resa'>Avis</li>
                                  <li className='filter_note'>Note</li>
                                </div>
                                <div className="filter-value">
                                  <div className="body-valueResa">
                                    <span onClick={handleCroissonAvis}>Croissant</span>
                                    <span className='ms-3' onClick={handleDeCroissonAvis}>Décroissant</span>
                                  </div>
                                  <div className="body-valueNote">
                                    <span onClick={handleCroissonNote}>Croissant</span>
                                    <span className='ms-3' onClick={handleDeCroissonNote}>Décroissant</span>
                                  </div>

                                </div>
                              </div>
                              <div className="footer-value">
                                <div className="action">
                                  <button className="btn btn_reinitialiser btn-sm" onClick={handleReset}>
                                    Reinitialiser
                                  </button>
                                  <button className="btn btn_filterFermer btn-sm" onClick={() => setOpenDropDown(false)}>
                                    Fermer
                                  </button>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div className='resto_avis_content' onClick={() => setOpenDropDown(false)}>

                          {loadData === true ?
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                className="load"
                                variant="info"
                                size="md"
                              />
                            </div> : data.map((item, index) => {
                              return viewAvis(item, index);
                            })
                          }


                          {showPaginate && <div className='d-flex justify-content-center mt-4'>
                            <Pagination
                              shape="rounded"
                              count={Math.ceil(totalPage)}
                              onChange={handlePage}
                            />
                          </div>
                          }


                        </div>
                      </div>
                    </Tab>
                  </Tabs>

                </div>


                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4'>
                  <div className='payement_plus'>
                    <div className='payement_plusContent'>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className='plus_restaurant'>
                          <div className='d-flex justify-content-center'>
                            <div className='titre_plus'>
                              <span><i className='fa fa-bolt'></i> Les + du restaurant</span>
                            </div>
                          </div>
                          <div className='plus_content'>
                            <div className='row'>
                              {dataResto?.serviceRestaurant?.length !== 0 ?
                                dataResto?.serviceRestaurant?.map((item, index) => {
                                  return (
                                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                      <div className='item_plus'>
                                        <div className='image_plus'>
                                          <img src={Plus} alt="avatar plus restaurant" />
                                        </div>
                                        <div className='value_plus'>
                                          <span>{item.libelle}</span>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                                : ''}
                              {dataResto?.regimeAlimentaires?.length !== 0 ?
                                dataResto?.regimeAlimentaires?.map((item, index) => {
                                  return (
                                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-x-6' key={index}>
                                      <div className='item_plus'>
                                        <div className='image_plus'>
                                          <img src={Plus} alt="avatar plus restaurant" />
                                        </div>
                                        <div className='value_plus'>
                                          <span>{item.libelle}</span>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                                : ''}


                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className='payement_restaurant'>
                          <div className='payement_restaurantContent'>
                            <div className='titre_payement'>
                              <span><i className='fa fa-money'></i> Mode de payement acceptés</span>
                            </div>
                          </div>
                          <div className='payement_content'>
                            <div className='row'>
                              {dataResto?.payements?.length !== 0 ?
                                dataResto?.payements?.map((item, index) => {
                                  return (<div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' key={index}>
                                    <div className='item_payement'>
                                      <div className='image_payement'>
                                        <img src={Money} alt="avatar plus restaurant" />
                                      </div>
                                      <div className='value_payement'>
                                        <span>{item.libelle}</span>
                                      </div>
                                    </div>
                                  </div>)
                                })

                                : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                        <div className='resto_map'>
                          <div className='resto_map_titre'>
                            <h4> <i className='fa fa-map-marker'></i>Localisation – Plan / adresse</h4>
                          </div>

                          <div className="resto_map_content">
                            <h5>Adresse</h5>
                            <p>{dataResto.adresse} : {dataResto.precision}</p>
                            <PhotoProvider>
                              {dataResto.urlPlan !== null ?
                                <div className='resto_map_image'>
                                  <PhotoView src={BASE_URL + dataResto.urlPlan}>
                                    <img src={BASE_URL + dataResto.urlPlan} alt="avatar map" />
                                  </PhotoView>
                                </div>
                                : ''}
                            </PhotoProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {dataResto?.photoRestos?.length !== 0 ?
                <div className="resto_photo_telecharger">
                  <div className='resto_photo_telecharger_titre'>
                    <h4> <i className='fa fa-photo'></i>Photo des clients</h4>
                  </div>
                  <div className='row'>
                    <PhotoProvider>
                      {dataResto?.photoRestos?.map((item, index) => {
                        return (
                          <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' key={index}>
                            <div className='resto_photo_img'>
                              <PhotoView src={BASE_URL + item.photoUrl}>
                                <img src={BASE_URL + item.photoUrl} alt="telecharger client" />
                              </PhotoView>
                            </div>
                          </div>
                        )
                      })}
                    </PhotoProvider>

                  </div>
                </div>
                : ""}
            </>

          }
          <p className="version">Version 1</p>



        </div>
        <Modal
          show={show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={handleClose}
        >
          <Modal.Body>
            <div className='modal_detail_menu'>
              <div className='header_detail_menu'>
                <h5>{dataMenu.nomMenu} à <span>{dataMenu.prixMenu} Ar</span></h5>
                <span className='close' onClick={handleClose}><i className='fa fa-close'></i></span>
              </div>
              <div className='content_detail_menu'>
                <div className='content_detail_description'>
                  <h6>Ce menu comprend:</h6>
                  <div className='content_detail_liste mt-2'>
                    <span className='detail_liste'>{dataMenu.platMenu !== "" ? dataMenu.platMenu : dataMenu.autrePlatMenu}</span>
                    {dataMenu.avecContenus?.length !== 0 ?
                      <>
                        <span className='detail_plus'>+</span>
                        {dataMenu.avecContenus?.map((item, index) => {
                          if (index === dataMenu.avecContenus.length - 1) {
                            return (<span className='detail_liste' key={index}>{item.libelle}</span>)
                          } else {
                            return (<>
                              <span className='detail_liste' key={index}>{item.libelle}</span>  <span className='detail_plus'>+</span>
                            </>)
                          }
                        })}
                      </>

                      : ''}



                  </div>
                  <h6>Ce menu disponible:</h6>
                  <div className='content_detail_liste mt-2'>
                    {dataMenu.moments?.map((item, index) => {
                      return (
                        <span className='detail_liste_disponible' key={index}>Au {item.libelle}</span>
                      )
                    })}

                  </div>
                  <div className='content_detail_liste mt-3'>
                    <span className='me-2' >Le</span>
                    {dataMenu.jours?.length !== 0 ? dataMenu.jours?.map((item, index) => {
                      return (<span className='detail_liste_disponible' key={index}>{item.libelle}</span>)
                    }) : <span>...</span>}

                  </div>
                </div>
                <div className='row'>
                  {dataMenu.entrerMenus?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Entrée</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenu.entrerMenus?.map((item, index) => {
                            if (index === dataMenu.entrerMenus.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}

                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenu.platMenus?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Plats</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenu.platMenus?.map((item, index) => {
                            if (index === dataMenu.platMenus.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenu.dessertMenus?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Dessert</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenu.dessertMenus?.map((item, index) => {
                            if (index === dataMenu.dessertMenus.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenu.autreMenus?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>{dataMenu.nomAutre}</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenu.autreMenus?.map((item, index) => {
                            if (index === dataMenu.autreMenus.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}



                </div>
                <p className='mt-3'>
                  {dataMenu.introduire}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>


        <Modal
          show={showSpecial}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={handleCloseSpecial}
        >
          <Modal.Body>
            <div className='modal_detail_menu'>
              <div className='header_detail_menu'>
                <h5>{dataMenuSpecial.libelle} à <span>{dataMenuSpecial.prix} Ar</span></h5>
                <span className='close' onClick={handleCloseSpecial}><i className='fa fa-close'></i></span>
              </div>
              <div className='content_detail_menu'>
                <div className='content_detail_description'>
                  <h6>Ce menu comprend:</h6>
                  <div className='content_detail_liste mt-2'>
                    <span className='detail_liste'>{dataMenuSpecial.platMenu !== "" ? dataMenuSpecial.platMenu : dataMenuSpecial.autrePlatMenu}</span>
                    {dataMenuSpecial.avecContenuSpecials?.length !== 0 ?
                      <>
                        <span className='detail_plus'>+</span>
                        {dataMenuSpecial.avecContenuSpecials?.map((item, index) => {
                          if (index === dataMenuSpecial.avecContenuSpecials.length - 1) {
                            return (<span className='detail_liste' key={index}>{item.libelle}</span>)
                          } else {
                            return (<>
                              <span className='detail_liste' key={index}>{item.libelle}</span>  <span className='detail_plus'>+</span>
                            </>)
                          }
                        })}
                      </>

                      : ''}



                  </div>


                </div>
                <div className='row'>
                  {dataMenuSpecial.entrerSpecials?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Entrée</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenuSpecial.entrerSpecials?.map((item, index) => {
                            if (index === dataMenuSpecial.entrerSpecials.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}

                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenuSpecial.platSpecials?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Plats</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenuSpecial.platSpecials?.map((item, index) => {
                            if (index === dataMenuSpecial.platSpecials.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenuSpecial.dessertSpecials?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>Dessert</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenuSpecial.dessertSpecials?.map((item, index) => {
                            if (index === dataMenuSpecial.dessertSpecials.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}

                  {dataMenuSpecial.autreSpecials?.length !== 0 ?
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                      <div className='content_detail_item'>
                        <div className='content_detail_itemTitre'>
                          <h6 className='text-center'>{dataMenuSpecial.nomAutre}</h6>

                        </div>
                        <div className='content_detail_itemListe'>
                          {dataMenuSpecial.autreSpecials?.map((item, index) => {
                            if (index === dataMenuSpecial.autreSpecials.length - 1) {
                              return (<span key={index}>{item.libelle}</span>)
                            } else {
                              return (<>
                                <span key={index}>{item.libelle}</span>
                                <hr />
                              </>)
                            }

                          })}
                        </div>
                      </div>
                    </div>
                    : ''}



                </div>
                <p className='mt-3'>
                  {dataMenuSpecial.introduire}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </div>


      <Footer />
    </div>
  )
}

export default RestoPage


